"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = refetch;
Object.defineProperty(exports, "typesQuery", {
  enumerable: true,
  get: function get() {
    return _typesQuery["default"];
  }
});
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _apolloClient = require("apollo-client");
var _getSchemaTypes = _interopRequireDefault(require("./getSchemaTypes.js"));
var _doesQueryContain = _interopRequireDefault(require("./doesQueryContain.js"));
var _typesQuery = _interopRequireDefault(require("./typesQuery.js"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function normalizePredicate(predicate, idField) {
  if (typeof predicate === 'function') return predicate;
  var ids = predicate;
  if (Array.isArray(ids)) ids = new Set(ids);else if (!(ids instanceof Set)) ids = new Set([ids]);
  return function (data) {
    return ids.has(data[idField]);
  };
}
function every(array, predicate) {
  var _iterator = _createForOfIteratorHelper(array),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _elem = _step.value;
      if (!predicate(_elem)) return false;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return true;
}
var typesPromise = null;
function refetch(_x, _x2, _x3, _x4) {
  return _refetch.apply(this, arguments);
}
function _refetch() {
  _refetch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(client, typenameOrTerms, predicate, idField) {
    var types, terms, queries, promises, _iterator2, _step2, _loop, _ret;
    return _regenerator["default"].wrap(function _callee3$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (client instanceof _apolloClient.ApolloClient) {
            _context4.next = 2;
            break;
          }
          throw new Error("client must be an ApolloClient, instead got: ".concat(String(client)));
        case 2:
          _context4.next = 4;
          return refetch.fetchTypeMetadata(client);
        case 4:
          types = _context4.sent;
          if (!(typeof typenameOrTerms === 'string')) {
            _context4.next = 9;
            break;
          }
          terms = [[typenameOrTerms, predicate, idField]];
          _context4.next = 14;
          break;
        case 9:
          if (!Array.isArray(typenameOrTerms)) {
            _context4.next = 13;
            break;
          }
          terms = typenameOrTerms;
          _context4.next = 14;
          break;
        case 13:
          throw new Error("invalid typename or terms: ".concat(typenameOrTerms));
        case 14:
          queries = client.queryManager.queries;
          promises = [];
          _iterator2 = _createForOfIteratorHelper(queries.values());
          _context4.prev = 17;
          _loop = /*#__PURE__*/_regenerator["default"].mark(function _loop() {
            var query, document, observableQuery, data, currentResult;
            return _regenerator["default"].wrap(function _loop$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  query = _step2.value;
                  document = query.document, observableQuery = query.observableQuery;
                  if (observableQuery) {
                    _context3.next = 4;
                    break;
                  }
                  return _context3.abrupt("return", 0);
                case 4:
                  if (!(observableQuery.options.fetchPolicy === 'cache-only')) {
                    _context3.next = 6;
                    break;
                  }
                  return _context3.abrupt("return", 0);
                case 6:
                  currentResult = observableQuery.currentResult();
                  if (currentResult) data = currentResult.data;
                  if (every(terms, function (_ref3) {
                    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 3),
                      typename = _ref4[0],
                      predicate = _ref4[1],
                      idField = _ref4[2];
                    return (0, _doesQueryContain["default"])(document, types, typename, data, predicate != null ? normalizePredicate(predicate, idField || 'id') : null);
                  })) {
                    promises.push(observableQuery.refetch());
                  }
                case 9:
                case "end":
                  return _context3.stop();
              }
            }, _loop);
          });
          _iterator2.s();
        case 20:
          if ((_step2 = _iterator2.n()).done) {
            _context4.next = 27;
            break;
          }
          return _context4.delegateYield(_loop(), "t0", 22);
        case 22:
          _ret = _context4.t0;
          if (!(_ret === 0)) {
            _context4.next = 25;
            break;
          }
          return _context4.abrupt("continue", 25);
        case 25:
          _context4.next = 20;
          break;
        case 27:
          _context4.next = 32;
          break;
        case 29:
          _context4.prev = 29;
          _context4.t1 = _context4["catch"](17);
          _iterator2.e(_context4.t1);
        case 32:
          _context4.prev = 32;
          _iterator2.f();
          return _context4.finish(32);
        case 35:
          _context4.next = 37;
          return promises;
        case 37:
        case "end":
          return _context4.stop();
      }
    }, _callee3, null, [[17, 29, 32, 35]]);
  }));
  return _refetch.apply(this, arguments);
}
refetch.fetchTypeMetadata = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(client) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!typesPromise) {
            refetch.setTypeMetadata(client.query({
              query: _typesQuery["default"]
            }));
          }
          // istanbul ignore next
          if (typesPromise) {
            _context.next = 3;
            break;
          }
          throw new Error('this should never happen');
        case 3:
          _context.next = 5;
          return typesPromise;
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x5) {
    return _ref.apply(this, arguments);
  };
}();
refetch.setTypeMetadata = function (metadata) {
  typesPromise = (0, _getSchemaTypes["default"])( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return metadata;
        case 2:
          return _context2.abrupt("return", _context2.sent);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
};